import { render, staticRenderFns } from "./CustomerManagement.vue?vue&type=template&id=2d523378&scoped=true"
import script from "./CustomerManagement.vue?vue&type=script&lang=js"
export * from "./CustomerManagement.vue?vue&type=script&lang=js"
import style0 from "./CustomerManagement.vue?vue&type=style&index=0&id=2d523378&prod&lang=less"
import style1 from "./CustomerManagement.vue?vue&type=style&index=1&id=2d523378&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d523378",
  null
  
)

export default component.exports